import { getMarket } from './utils/settings';

const { country } = getMarket();

// Copy from backend config (feature_family_enabled):
// https://github.com/ingka-group-digital/igift-backend/blob/main/infrastructure/terraform/milieus/prod/vars.tfvars
const ikeaFamilyRequired =
  'au,be,cz,de,es,fi,hu,it,jp,kr,nl,no,pt,ro,rs,se,si,sk';

export const webFeatureConfig = {
  familyFeatureEnabled: ikeaFamilyRequired.split(',').includes(country),
};
